import { useLinkTo } from '@react-navigation/native'
import { Text, Button } from 'native-base'
import React from 'react'
import { Trans } from 'react-i18next'

import { useConfig } from '../../context/config'
import { RootStackParamList } from '../../navigation'

export const TermsAndConditionsFooter: React.FC = () => {
  const { config } = useConfig()
  const linkTo = useLinkTo<RootStackParamList>()

  return (
    <Text fontSize="sm" textAlign="center">
      <Trans i18nKey={'screens.welcome.tAndC.text'} values={{ partnerName: config.partnerName }}>
        <Button size={'sm'} onPress={() => linkTo('/terms-and-conditions')} variant="link" p={0} m={0} />
      </Trans>
    </Text>
  )
}
